// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__3VT01"};